/**
 * 年度计划
 */
import React from 'react';
import { Row, Col, Icon, Tooltip, Button, Select } from 'antd';
import moment from 'moment';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import messager from '../../ui/messager';
//年度计划编辑
import YearBudgetEdit from './YearBudgetEdit';
//年度计划拷贝
import YearBudgetCopy from './YearBudgetCopy';
import { global_data } from '../../ui/auth'

class YearBudgetIndex extends React.Component {

    columns = [{
        title: '部门/项目',
        dataIndex: 'name',
        width: '10%',
        // render: (text, record, index) => {
        //     return record.type === 0 ? record.orgName : record.itemName;
        // }
    }, {
        title: '类型',
        dataIndex: 'type',
        width: '10%',
        format: { 0: '基本信息', 1: '业务指标', 2: '工作总结', 3: '预算指标' }
    }, {
        title: '预算编制人数',
        dataIndex: 'budgetStaff',
        width: '10%',
    }, {
        title: '预算外包人数',
        dataIndex: 'budgetEpiboly',
        width: '10%',
    }, {
        title: '预算金额',
        dataIndex: 'moneyBudget',
        width: '10%',
    }, {
        title: '状态',
        dataIndex: 'state',
        width: '10%',
        format: { 0: '正常', 1: '删除', 2: '停用' }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) =>
        (<div>
            {global_data.authCode.includes("REPORT_YEAR_BUDGET_UPDATE")?
            <Tooltip title="修改">
                <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
            </Tooltip>
            :""}
            {global_data.authCode.includes("REPORT_YEAR_BUDGET_DELETE")?
            <Tooltip title="删除">
                <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, text)} />
            </Tooltip>
            :""}
            {global_data.authCode.includes("REPORT_YEAR_BUDGET_ENABLE")?
            <Tooltip title="启用">
                <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.enable.bind(this, text)} />
            </Tooltip>
            :""}
            {global_data.authCode.includes("REPORT_YEAR_BUDGET_DISABLE")?
            <Tooltip title="停用">
                <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.disable.bind(this, text)} />
            </Tooltip>
            :""}
        </div>)
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {
            year: moment().year(),
        },
        formula: {},
        loadingVisible: false,


        yearList: [],

        copyVisible: false,
    };

    componentDidMount() {
        let year = moment().year();
        //开始年份从2019开始，然后累加到当前年份的下一年
        let yearList = [];
        for (let i = 2019; i <= year + 1; i++) {
            yearList.push(i);
        }
        this.setState({ yearList: yearList });
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    //新增
    add = () => {
        let year = this.state.queryData.year;
        this.setState({ visible: true, editData: { year: year, type: "0" } });
    }

    //修改
    update = (info, e) => {
        this.setState({ editData: info, visible: true });
    }

    //删除
    delete = (id, e) => {
        messager.confirm("是否删除该年度计划？", () => {
            http.post({
                url: "/yearBudget/delteYearBudget",
                data: { id: id },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    //拷贝年度计划
    copy = () => {
        let year = moment().year();
        this.setState({ copyVisible: true, editData: { "sourceYear": "" + (year - 1), "targetYear": "" + year } });
    }

    selectChange = (value) => {
        let { queryData } = this.state;
        queryData.year = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //停用
    disable = (id, e) => {
        messager.confirm("是否停用该年度计划？", () => {
            http.post({
                url: "/yearBudget/disableBudget",
                data: { id: id },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("停用成功！");
                }
            });
        });
    }

    //启用
    enable = (id, e) => {
        messager.confirm("是否启用该年度计划？", () => {
            http.post({
                url: "/yearBudget/enableBudget",
                data: { id: id },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("启用成功！");
                }
            });
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Select onChange={this.selectChange} defaultValue={moment().year()} allowClear={false} style={{ width: "100px", margin: '0 10px' }}>
                                    {this.state.yearList.map(item => (
                                        <Select.Option key={item}>{item}</Select.Option>
                                    ))}
                                </Select>
                                {global_data.authCode.includes("REPORT_YEAR_BUDGET_COPY")?
                                <Button type="primary" onClick={this.copy} style={{ "float": "right", "marginLeft": "10px" }}>复制</Button>
                                :""}
                                {global_data.authCode.includes("REPORT_YEAR_BUDGET_ADD")?
                                <Button type="primary" onClick={this.add} style={{ "float": "right" }}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/yearBudget/findYearBudget"
                    columns={this.columns}
                    treeTable={true}
                    page={false}
                    defaultExpandAllRows={true}
                    initParams={this.state.queryData}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                    getLoadData={(func) => { this.setState({ getLoadData: func }) }}
                />
                <YearBudgetEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    yearBudgetData={this.state.getLoadData}
                />
                <YearBudgetCopy
                    visible={this.state.copyVisible}
                    onCancel={() => this.setState({ copyVisible: false })}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    yearList={this.state.yearList}
                />
            </div>
        )
    }
}

export default YearBudgetIndex;